export function getUserInitials(firstName?: string | null, lastName?: string | null): string {
	const first = (firstName ?? '').trim();
	const last = (lastName ?? '').trim();
	const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
	return initials || '?';
}

export function isSystemAvatarUserId(userId: number | string | null | undefined): boolean {
	if (userId == null) {
		return false;
	}
	return String(userId) === '-1' || String(userId) === '-2';
}
